const HideZeroAmountReducers = (state = false, action) => {
  switch (action.type) {
    case "openHideZeroAmount":
      return (state = true);
    case "closeHideZeroAmount":
      return (state = false);
    default:
      return state;
  }
};

export default HideZeroAmountReducers;
